import { OccSeatingScreenPosition } from '../../../context/occ/types/config/seating/screen-position';
import { getMapDimension } from './map';
/**
 * Returns the SVG rectangle of the screen.
 */
export function getScreenRectangle(screenBoundary, mapRectangle, scaleFactor, config) {
    const invertSeatMap = config.screen.position === OccSeatingScreenPosition.Top;
    const screenWidth = screenBoundary.right - screenBoundary.left;
    const leftPercentage = invertSeatMap
        ? 100 - screenBoundary.right - mapRectangle.x
        : screenBoundary.left - mapRectangle.x;
    const { paddingY } = config.map;
    const y = invertSeatMap ? 0 + paddingY : mapRectangle.height - config.screen.height - paddingY;
    return {
        y: y,
        x: getMapDimension(leftPercentage, scaleFactor),
        width: getMapDimension(screenWidth, scaleFactor),
        height: config.screen.height
    };
}
//# sourceMappingURL=screen.js.map